module.exports = __webpack_public_path__ + "img/8. History of Production (1).4c21a18c.svg";